enum SDCLinkButtonVariant {
  Standard = 'standard',
  Dark = 'dark',
}

export default SDCLinkButtonVariant;
